// TAVEN public taxonomy — reversible config mapping (Phase B).
// 14 public departments -> the existing 48 canonical collection handles.
// Nothing here creates/renames/deletes collections; it only groups existing
// canonical handles for navigation and declares reversible aliases.

const L = (en, fr, ht, es) => ({ en, fr, ht, es });

// 14 departments, each mapping to existing canonical collection handles only.
export const DEPARTMENTS = [
  { key: "womens-clothing", label: L("Women's Clothing", "Vêtements Femme", "Rad Fanm", "Ropa de Mujer"), items: [
    { handle: "womens-tops", label: L("Tops & Sets", "Hauts & Ensembles", "Kòsaj & Ansanm", "Tops y Conjuntos") },
    { handle: "womens-bottoms", label: L("Bottoms", "Bas", "Pantalon", "Pantalones") },
    { handle: "womens-outerwear", label: L("Outerwear & Jackets", "Manteaux & Vestes", "Manto & Jakèt", "Abrigos y Chaquetas") },
    { handle: "womens-accessories", label: L("Accessories", "Accessoires", "Akseswa", "Accesorios") },
    { handle: "wedding-event-dresses", label: L("Wedding & Event Dresses", "Robes de Mariage", "Rad Maryaj", "Vestidos de Fiesta") },
  ] },
  { key: "mens-clothing", label: L("Men's Clothing", "Vêtements Homme", "Rad Gason", "Ropa de Hombre"), items: [
    { handle: "mens-tshirts", label: L("T-Shirts", "T-Shirts", "T-Shirt", "Camisetas") },
    { handle: "mens-outerwear", label: L("Outerwear & Jackets", "Manteaux & Vestes", "Manto & Jakèt", "Abrigos y Chaquetas") },
    { handle: "mens-bottoms", label: L("Bottoms", "Bas", "Pantalon", "Pantalones") },
    { handle: "mens-hats-caps", label: L("Hats & Caps", "Chapeaux & Casquettes", "Chapo & Kas", "Sombreros y Gorras") },
    { handle: "mens-underwear", label: L("Underwear & Loungewear", "Sous-vêtements", "Rad anndan", "Ropa Interior") },
  ] },
  { key: "beauty", label: L("Health, Beauty & Hair", "Santé & Beauté", "Sante & Bote", "Salud y Belleza"), items: [
    { handle: "skin-care", label: L("Skin Care", "Soins de la Peau", "Swen Po", "Cuidado de la Piel") },
    { handle: "makeup", label: L("Makeup", "Maquillage", "Makiyaj", "Maquillaje") },
    { handle: "beauty-tools", label: L("Beauty Tools", "Outils de Beauté", "Zouti Bote", "Herramientas de Belleza") },
    { handle: "nail-art", label: L("Nail Art & Tools", "Ongles & Outils", "Zong & Zouti", "Uñas y Herramientas") },
    { handle: "wigs-extensions", label: L("Wigs & Extensions", "Perruques & Extensions", "Perik & Ekstansyon", "Pelucas y Extensiones") },
    { handle: "hair-accessories", label: L("Hair Accessories", "Accessoires Cheveux", "Akseswa Cheve", "Accesorios de Cabello") },
  ] },
  { key: "jewelry", label: L("Jewelry & Watches", "Bijoux & Montres", "Bijou & Mont", "Joyería y Relojes"), items: [
    { handle: "fashion-jewelry", label: L("Fashion Jewelry", "Bijoux Fantaisie", "Bijou Mòd", "Joyería de Moda") },
    { handle: "fine-jewelry", label: L("Fine Jewelry", "Bijoux Fins", "Bijou Fen", "Joyería Fina") },
    { handle: "wedding-engagement-jewelry", label: L("Wedding & Engagement", "Mariage & Fiançailles", "Maryaj & Fiyansay", "Boda y Compromiso") },
    { handle: "mens-watches", label: L("Men's Watches", "Montres Homme", "Mont Gason", "Relojes de Hombre") },
    { handle: "womens-watches", label: L("Women's Watches", "Montres Femme", "Mont Fanm", "Relojes de Mujer") },
  ] },
  { key: "bags-shoes", label: L("Bags & Shoes", "Sacs & Chaussures", "Sak & Soulye", "Bolsos y Zapatos"), items: [
    { handle: "womens-shoes", label: L("Women's Shoes", "Chaussures Femme", "Soulye Fanm", "Zapatos de Mujer") },
    { handle: "mens-shoes", label: L("Men's Shoes", "Chaussures Homme", "Soulye Gason", "Zapatos de Hombre") },
    { handle: "womens-bags", label: L("Women's Bags & Luggage", "Sacs Femme", "Sak Fanm", "Bolsos de Mujer") },
    { handle: "mens-bags", label: L("Men's Bags & Luggage", "Sacs Homme", "Sak Gason", "Bolsos de Hombre") },
  ] },
  { key: "home", label: L("Home, Garden & Furniture", "Maison & Jardin", "Kay & Jaden", "Hogar y Jardín"), items: [
    { handle: "home-textiles", label: L("Home Textiles", "Textiles Maison", "Twal Kay", "Textiles del Hogar") },
    { handle: "kitchen-dining-bar", label: L("Kitchen, Dining & Bar", "Cuisine & Table", "Kizin & Manje", "Cocina y Comedor") },
    { handle: "home-storage", label: L("Home Storage", "Rangement", "Depo Kay", "Almacenamiento") },
    { handle: "arts-crafts", label: L("Arts, Crafts & Sewing", "Loisirs Créatifs", "Atizana", "Manualidades") },
    { handle: "party-supplies", label: L("Festive & Party Supplies", "Fêtes & Décorations", "Fèt & Dekorasyon", "Fiestas y Decoración") },
    { handle: "home-appliances", label: L("Home Appliances", "Électroménager", "Aparèy Kay", "Electrodomésticos") },
  ] },
  { key: "home-improvement", label: L("Home Improvement", "Bricolage", "Amelyorasyon Kay", "Mejoras del Hogar"), items: [
    { handle: "led-lighting", label: L("LED Lighting", "Éclairage LED", "Limyè LED", "Iluminación LED") },
    { handle: "indoor-lighting", label: L("Indoor Lighting", "Éclairage Intérieur", "Limyè Andedan", "Iluminación Interior") },
    { handle: "outdoor-lighting", label: L("Outdoor Lighting", "Éclairage Extérieur", "Limyè Deyò", "Iluminación Exterior") },
    { handle: "tools-hardware", label: L("Tools & Hardware", "Outils & Quincaillerie", "Zouti & Materyèl", "Herramientas") },
  ] },
  { key: "electronics", label: L("Consumer Electronics", "Électronique", "Elektwonik", "Electrónica"), items: [
    { handle: "smart-electronics", label: L("Smart Electronics", "Objets Connectés", "Elektwonik Entèlijan", "Electrónica Inteligente") },
    { handle: "home-audio-video", label: L("Home Audio & Video", "Audio & Vidéo", "Odyo & Videyo", "Audio y Video") },
    { handle: "camera-photo", label: L("Camera & Photo", "Photo & Caméra", "Kamera & Foto", "Cámara y Foto") },
    { handle: "video-games", label: L("Video Games", "Jeux Vidéo", "Jwèt Videyo", "Videojuegos") },
    { handle: "portable-audio", label: L("Portable Audio & Video", "Audio Portable", "Odyo Pòtab", "Audio Portátil") },
    { handle: "office-electronics", label: L("Office Electronics", "Électronique Bureau", "Elektwonik Biwo", "Electrónica de Oficina") },
    { handle: "storage-devices", label: L("Storage Devices", "Stockage", "Depo Done", "Almacenamiento") },
    { handle: "security-protection", label: L("Security & Protection", "Sécurité", "Sekirite", "Seguridad") },
  ] },
  { key: "phones", label: L("Phones & Accessories", "Téléphones", "Telefòn", "Teléfonos"), items: [
    { handle: "phone-cases", soon: true, label: L("Phone Cases & Covers", "Coques Téléphone", "Kès Telefòn", "Fundas") },
    { handle: "phone-accessories", label: L("Phone Accessories", "Accessoires Téléphone", "Akseswa Telefòn", "Accesorios de Teléfono") },
  ] },
  { key: "sports", label: L("Sports & Outdoors", "Sport & Plein Air", "Espò & Deyò", "Deportes"), items: [
    { handle: "sportswear", label: L("Sportswear", "Vêtements de Sport", "Rad Espò", "Ropa Deportiva") },
    { handle: "cycling-gear", label: L("Cycling Gear", "Cyclisme", "Ekipman Bisiklèt", "Ciclismo") },
  ] },
  { key: "pet-supplies", label: L("Pet Supplies", "Animalerie", "Bèt Kay", "Mascotas"), items: [
    { handle: "pet-supplies", label: L("Pet Supplies", "Animalerie", "Bèt Kay", "Mascotas") },
  ] },
  { key: "toys-kids", label: L("Toys, Kids & Babies", "Jouets & Enfants", "Jwèt & Timoun", "Juguetes y Niños"), items: [
    { handle: "toys-kids", soon: true, label: L("Coming Soon", "Bientôt", "Byento", "Próximamente") },
  ] },
  { key: "automobiles", label: L("Automobiles & Motorcycles", "Auto & Moto", "Machin & Moto", "Autos y Motos"), items: [
    { handle: "automobiles", soon: true, label: L("Coming Soon", "Bientôt", "Byento", "Próximamente") },
  ] },
  { key: "computer-office", label: L("Computer & Office", "Informatique & Bureau", "Òdinatè & Biwo", "Informática y Oficina"), items: [
    { handle: "computer-office", soon: true, label: L("Coming Soon", "Bientôt", "Byento", "Próximamente") },
  ] },
];

// Reversible aliases: old / duplicate / Shopify handles -> canonical CJ handle.
// Used to resolve backward-compatible URLs; these never appear as separate menu items.
export const COLLECTION_ALIASES = {
  // Mongo orphan aliases
  "perfume-fragrance": "skin-care",
  "mens-accessories": "mens-hats-caps",
  // Shopify duplicate/legacy handles -> nearest canonical CJ destination
  "fashion": "womens-tops",
  "womens-clothing": "womens-tops",
  "womens-clothing-1": "womens-tops",
  "mens-clothing": "mens-tshirts",
  "mens-clothing-1": "mens-tshirts",
  "consumer-electronics": "smart-electronics",
  "consumer-electronics-1": "smart-electronics",
  "technology": "smart-electronics",
  "electronic-components-supplies": "smart-electronics",
  "jewelry-accessories": "fashion-jewelry",
  "jewelry-accessories-1": "fashion-jewelry",
  "watches": "womens-watches",
  "lights-lighting": "indoor-lighting",
  "lights-lighting-1": "indoor-lighting",
  "furniture": "home-storage",
  "furniture-1": "home-storage",
  "home-garden": "home-textiles",
  "home-garden-1": "home-textiles",
  "bedding-bath": "home-textiles",
  "kitchen-gadgets": "kitchen-dining-bar",
  "home-storage-1": "home-storage",
  "hair-extensions-wigs": "wigs-extensions",
  "hair-extensions-wigs-1": "wigs-extensions",
  "shoes": "womens-shoes",
  "shoes-1": "womens-shoes",
  "travel-luggage": "womens-bags",
  "luggage-bags": "womens-bags",
  "underwear": "mens-underwear",
  "underwear-1": "mens-underwear",
  "weddings-events": "wedding-event-dresses",
  "weddings-events-1": "wedding-event-dresses",
  "premium-beauty": "skin-care",
  "fragrance": "skin-care",
  "taven-fragrance": "skin-care",
  "toys-hobbies": "toys-kids",
  "toys-hobbies-1": "toys-kids",
  "mother-kids": "toys-kids",
  "mother-kids-1": "toys-kids",
  "automotive": "automobiles",
  "automobiles-parts-accessories": "automobiles",
  "computer-office-1": "computer-office",
  "phones-telecommunications": "phone-accessories",
  "phones-telecommunications-1": "phone-accessories",
};

// Dynamic merchandising rails (public but NOT part of the department taxonomy).
export const MERCHANDISING = ["best-sellers", "trending-deals", "luxury-essentials", "affiliate-boutique", "home-favorites", "new-arrivals"];
// Channel-only (never in public department menu).
export const CHANNELS = ["taven-dropshipping", "taven-wholesale"];
// Hidden/private operational queues (never public).
export const HIDDEN = ["needs-review", "compliance-review", "pricing-review", "uncategorized-review"];

// Handles with zero published products -> show "Coming Soon", never fake fill.
export const COMING_SOON = new Set(["phone-cases", "toys-kids", "automobiles", "computer-office"]);

export const resolveCollectionHandle = (handle) => COLLECTION_ALIASES[handle] || handle;
